import React from 'react';
import { ExternalLink, Minimize2, X } from 'lucide-react';
import { Button } from './ui/button';

function AdExpanded({ ad, onClose, onOpenLink, onCollapse }) {
  if (!ad) return null;

  return (
    <div className="fixed inset-0 z-[90] bg-black/45 p-3 sm:p-6" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="mx-auto flex h-full max-w-2xl items-end sm:items-center" onClick={(event) => event.stopPropagation()}>
        <div className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl">
          <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
            <div>
              <p className="text-xs uppercase tracking-[0.14em] text-slate-500">Annonce sponsorisee</p>
              <p className="text-sm font-semibold text-slate-900">{ad.sponsor || 'Partenaire SmartInventory'}</p>
            </div>
            <div className="flex items-center gap-2">
              <Button type="button" variant="outline" size="sm" className="h-8 px-2" onClick={onCollapse}>
                <Minimize2 className="h-4 w-4" />
              </Button>
              <Button type="button" variant="outline" size="sm" className="h-8 px-2" onClick={onClose}>
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>

          <div className="grid gap-4 p-4 sm:grid-cols-[1.2fr,1fr]">
            <div className="overflow-hidden rounded-xl bg-slate-100">
              <img src={ad.imageUrl} alt={ad.title} className="h-52 w-full object-cover sm:h-full" loading="lazy" />
            </div>

            <div className="flex min-w-0 flex-col gap-3">
              <h3 className="text-lg font-bold text-slate-900">{ad.title}</h3>
              <p className="text-sm text-slate-600">{ad.description}</p>

              <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600">
                {ad.provider === 'google_admob'
                  ? 'Format Android: l annonce AdMob est declenchee via le bouton d action.'
                  : 'Format partenaire direct: annonce interactive premium.'}
              </div>

              <Button type="button" className="mt-auto w-full bg-emerald-600 text-white hover:bg-emerald-700" onClick={onOpenLink}>
                {ad.ctaText || 'Voir l offre'}
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdExpanded;
